import LandingsPage from "@/Layouts/LandingsPage";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";
import CTA from "@/Sections/CTA";
import Features from "@/Sections/Features";
import Phases from "@/Sections/Phases";
import Promises from "@/Sections/Promises";
import Transformations from "@/Sections/Transformations";
import ListenStories from "../ListenStories";

export default () => {
    return (
        <LandingsPage>
            <Head>
                <title>Twaalf weken programma</title>
                <link rel="canonical" href={route("twelve-week-program")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – personal training Uden en Schijndel onderscheidt zich door leden te begeleiden op fysiek en mentaal gebied. Met al meer dan 500 transformaties is dit het bewezen programma om jou met meer zelfvertrouwen in je schoenen te laten staan dan ooit tevoren!"
                />
                <meta
                    property="og:description"
                    content="WE ARE – personal training Uden en Schijndel onderscheidt zich door leden te begeleiden op fysiek en mentaal gebied. Met al meer dan 500 transformaties is dit het bewezen programma om jou met meer zelfvertrouwen in je schoenen te laten staan dan ooit tevoren!"
                />
                <meta
                    property="og:url"
                    content={route("twelve-week-program")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Twaalf weken programma - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl">
                        your change!
                    </h1>
                    <p className="mt-6 max-w-3xl text-xl text-center mx-auto text-gray-100">
                        Verandering begint niet bij wat je bent maar wie je
                        denkt dat je bent. WE ARE - personal training Uden en
                        Schijndel biedt jou een uniek programma waarin voeding,
                        training en mentale veerkracht een belangrijke rol
                        spelen. Met alle behaalde resultaten is dit het bewezen
                        programma om jou te voorzien van meer zelfvertrouwen en
                        een lach op je gezicht!
                    </p>
                </Hero> */}

                {/* <Features classNames="xs:pt-8 sm:pt-8 md:pt-16 lg:pt-16" /> */}

                <div
                    className="relative lg:p-32 sm:p-8 xs:p-8 lg:h-[850px] xs:h-[100%] md:h-[750px]"
                    id="more-info"
                >
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/celqf-xRF5I"
                        title="WE ARE - your physical and mental personal training - reviews"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                    <div className="text-center">
                        <Link
                            to="contact"
                            smooth={true}
                            offset={0}
                            duration={800}
                            className="mt-12 uppercase ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Dit wil ik ook!
                        </Link>
                    </div>
                </div>

                <Phases />

                <Transformations />

                <CTA
                    src="/assets/personal-training-locatie-schijndel.jpg"
                    srcWebp="/assets/webp/personal-training-locatie-schijndel.webp"
                    textAlign="text-center"
                />

                {/* <Promises classNames="xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16" /> */}
                <ListenStories classNames="xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16" />

                <div
                    className="relative xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16"
                    id="transformations"
                >
                    <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                        <div className="text-center">
                            <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                Nog niet overtuigd?
                            </h2>
                            <div
                                className="relative lg:p-32 sm:p-8 xs:p-8 lg:h-[850px] xs:h-[500px] md:h-[750px] lg:pb-8"
                                id="success-stories"
                            >
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src="https://www.youtube.com/embed/lxOrVuw7bLI?si=Ch5BcRh8GhmqF0g2"
                                    title="WE ARE - your physical and mental personal training - reviews"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <div className="text-center">
                                <a
                                    href={route("stories")}
                                    className="uppercase ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                                >
                                    Bekijk alle verhalen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </LandingsPage>
    );
};
